import Swiper from 'swiper/swiper-bundle';
import 'swiper/swiper-bundle.min.css';

const cardModules = document.querySelectorAll('.card-slider');

if (cardModules) {
	cardModules.forEach(cardModule => {
		const cardSwiper = cardModule.querySelector('.card-slider__swiper');
		const progressBar = cardModule.querySelector('.slider-progress-bar');

		if (cardSwiper) {
			const options = {
				slidesPerView: 'auto',
				spaceBetween: 35,
				centeredSlides: false,
				loop: false,
				shortSwipes: false,
				freeMode: true,
				keyboard: {
					enabled: true,
					onlyInViewport: true,
				},
				mousewheel: {
					enabled: true,
					forceToAxis: true,
				},
				pagination: {
					el: progressBar,
					type: 'progressbar',
				},
				breakpoints: {
					992: {
						spaceBetween: 30,
					},
				},
			};

			const swiper = new Swiper(cardSwiper, options);

			const prevArrow = cardSwiper.querySelector('.js-slider-arrow-prev');
			const nextArrow = cardSwiper.querySelector('.js-slider-arrow-next');

			if (prevArrow) {
				prevArrow.addEventListener('click', () => {
					swiper.slidePrev();
				});
			}

			if (nextArrow) {
				nextArrow.addEventListener('click', () => {
					swiper.slideNext();
				});
			}
		}
	});
}
